import LayoutContainer from 'components/Common/LayoutContainer'
import React, { useReducer } from 'react'
import styled from 'styled-components'
import BusinessTravellerSignupBusinessExists from './steps/BusinessTravellerSignupBusinessExists'
import BusinessTravellerSignupEmailValidation from './steps/BusinessTravellerSignupEmailValidation'
import BusinessTravellerSignupAccountDetails from './steps/BusinessTravellerSignupAccountDetails'
import BusinessTravellerSignupLinkAccount from './steps/BusinessTravellerSignupLinkAccount'
import BusinessTravellerSignupCreatePassword from './steps/BusinessTravellerSignupCreatePassword'
import {
  BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS,
  BusinessTravellerBusinessOnboardingDispatchContext,
  BusinessTravellerBusinessOnboardingStateContext,
  businessTravellerBusinessOnboardingStateReducer,
} from 'businessTraveller/contexts/BusinessTravellerBusinessOnboardingContexts'

const SignupContainer = styled(LayoutContainer)`
  padding: 0;
`

const steps: App.BusinessTraveller.BusinessSignupSteps = [{
  label: 'Email address',
  stepKey: 'validate_email',
}, {
  label: 'Account details',
  stepKey: 'account_details',
}, {
  label: 'Create password',
  stepKey: 'create_password',
}]

function BusinessTravellerBusinessSignupStepper() {
  const [accountSetupState, accountSetupDispatch] =
    useReducer(businessTravellerBusinessOnboardingStateReducer, {
      step: BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.VALIDATE_EMAIL,
      businessName: '',
      adminEmail: '',
    })
  const { step } = accountSetupState!

  return (
    <SignupContainer>
      <BusinessTravellerBusinessOnboardingStateContext.Provider value={accountSetupState!}>
        <BusinessTravellerBusinessOnboardingDispatchContext.Provider value={accountSetupDispatch}>
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.VALIDATE_EMAIL &&
            <BusinessTravellerSignupEmailValidation steps={steps} />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.ACCOUNT_DETAILS &&
            <BusinessTravellerSignupAccountDetails steps={steps} />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.LINK_ACCOUNT &&
            <BusinessTravellerSignupLinkAccount steps={steps} />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.BUSINESS_EXISTS &&
            <BusinessTravellerSignupBusinessExists />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.CREATE_PASSWORD &&
            <BusinessTravellerSignupCreatePassword steps={steps} />}
        </BusinessTravellerBusinessOnboardingDispatchContext.Provider>
      </BusinessTravellerBusinessOnboardingStateContext.Provider>
    </SignupContainer>
  )
}

export default BusinessTravellerBusinessSignupStepper
